import React, { useRef } from "react";
import "./MostrarCotizacion.css";

const MostrarCotizacion = ({ datos }) => {
  const componenteRef = useRef(null);

  if (!datos) return <p>No hay cotización para mostrar.</p>;

  const {
    numero,
    cliente,
    producto,
    dias,
    horas,
    precioUnitario,
    valorNeto,
    iva,
    valorTotal,
    descripcion,
    nota,
    fecha,
  } = datos;

  const fechaFormateada = new Date(fecha).toLocaleDateString("es-CL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const totalCalculado = valorTotal ?? (valorNeto ?? 0) + (iva ?? 0);

  const handlePrint = () => {
  const content = componenteRef.current.innerHTML;

  // Dimensiones mínimas y centradas
  const width = 800;
  const height = 1000;
  const left = (window.screen.width / 2) - (width / 2);
  const top = (window.screen.height / 2) - (height / 2);

  const printWindow = window.open(
    "",
    "_blank",
    `width=${width},height=${height},top=${top},left=${left},resizable=no,scrollbars=no`
  );

  printWindow.document.write(`
    <html>
      <head>
        <title>Cotización</title>
        <style>
          body {
            font-family: 'Segoe UI', sans-serif;
            margin: 30px;
            background-color: #fdfdfd;
          }
          .cotizacion-container {
            max-width: 900px;
            margin: auto;
            padding: 30px;
            border: 1px solid #ccc;
            border-radius: 12px;
            box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
          }
          .cotizacion-header {
            display: flex;
            align-items: center;
            border-bottom: 2px solid #007BFF;
            padding-bottom: 10px;
            margin-bottom: 20px;
          }
          .cotizacion-logo {
            width: 80px;
            margin-right: 20px;
          }
          .cotizacion-title {
            margin: 0;
            font-size: 1.8em;
            color: #007BFF;
          }
          .cotizacion-subtitle {
            margin: 0;
            font-size: 1.2em;
            color: #333;
          }
          .cotizacion-info {
            margin: 20px 0;
            font-size: 1em;
            color: #444;
          }
          .cotizacion-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          .cotizacion-table th,
          .cotizacion-table td {
            border: 1px solid #ccc;
            padding: 10px;
            text-align: center;
          }
          .cotizacion-table th {
            background-color: #f0f0f0;
            font-weight: bold;
          }
          .cotizacion-details {
            font-size: 1em;
            color: #333;
            line-height: 1.6;
          }
          .boton-imprimir {
            display: none;
          }
        </style>
      </head>
      <body>
        ${content}
        <script>
          window.onload = function() {
            window.print();
            setTimeout(() => window.close(), 1000);
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
};


  return (
    <div style={{ marginTop: 30 }}>
      <div ref={componenteRef} className="cotizacion-container">
        <div className="cotizacion-header">
          <img
            src="/logo_movimonte_nuevo.png"
            alt="Logo Empresa"
            className="cotizacion-logo"
          />
          <div>
            <h1 className="cotizacion-title">MOVIMENTOMONTE SPA</h1>
            <h2 className="cotizacion-subtitle">Presupuesto N° {numero}</h2>
          </div>
        </div>

        <div className="cotizacion-info">
          <p><strong>Fecha emisión:</strong> {fechaFormateada}</p>
          <p><strong>Cliente:</strong> {cliente}</p>
        </div>

        <div className="tabla-scroll">
          <div style={{ minWidth: "600px" }}></div>
          <table className="cotizacion-table">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Días</th>
                <th>Horas</th>
                <th>Precio Unitario</th>
                <th>Valor Neto</th>
                <th>IVA (19%)</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{producto}</td>
                <td>{dias}</td>
                <td>{horas}</td>
                <td>${precioUnitario?.toLocaleString("es-CL")}</td>
                <td>${valorNeto?.toLocaleString("es-CL")}</td>
                <td>${iva?.toLocaleString("es-CL")}</td>
                <td>${totalCalculado?.toLocaleString("es-CL")}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="cotizacion-details">
          <p><strong>Descripción:</strong> {descripcion}</p>
          <p><strong>Nota:</strong> {nota}</p>
        </div>
      </div>

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button onClick={handlePrint} className="boton-imprimir">
          Imprimir / Guardar PDF
        </button>
      </div>
    </div>
  );
};

export default MostrarCotizacion;
